<button
  [ngClass]="buttonClass"
  (click)="launchWhatsAppSignup()"
  [disabled]="disabledButton">

  @if (!loading) {
    <span>{{ labelButton }}</span>
  }

  @if (loading) {
    <span class="d-flex align-items-center gap-2">
      <span class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
      <span>{{ 'whatsappSignup.home.loading' | translate }}</span>
    </span>
  }
</button>
